import Header from '../../components/Header/Header';
import styles from './JoinSuccess.module.scss';
import joinSuccess from '../../assets/joinSuccess.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactPixel from 'react-facebook-pixel';
import { useEffect } from 'react';

function JoinSuccess() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // useEffect(() => {
  //   ReactPixel.track('CompleteRegistration');
  // }, []);
  return (
    <div>
      <Header />
      <div className={styles.content}>
        <img src={joinSuccess} alt="joinSuccess" />
        <h2>{t('joinSuccess.1')}</h2>
        <span>{t('joinSuccess.2')}</span>
        <p>{t('joinSuccess.3')}</p>
        <button onClick={() => navigate('/')}>{t('joinSuccess.4')}</button>
      </div>
    </div>
  );
}
export default JoinSuccess;
